import type { TaskBase } from "../base/TaskBase"
import type { TaskName } from "../TaskName"

export type TaskMergeOptions = {
  readonly enum: TaskName.TASK_MERGE
} & TaskBase
